export default {
  tileTitle: {
    en: "Identity information",
    ja: "身元情報"
  },

  nationalityLabel: {
    en: "Nationality",
    ja: "国籍"
  },
  firstNameLabel: {
    en: "First name",
    ja: "ファーストネーム"
  },
  lastNameLabel: {
    en: "Last name",
    ja: "苗字"
  },
  middleNameLabel: {
    en: "Middle name",
    ja: "ミドルネーム"
  },
  birthDateLabel: {
    en: "Birth Date",
    ja: "生年月日"
  }
}
